<script>
import BBtn from "@/admin/components/base/Btn.vue";

export default {
  extends: BBtn,
};
</script>
